var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Base',{attrs:{"detail":_vm.detail.pigLineCustomerInfo || {}}}),_c('Customer',{attrs:{"detail":_vm.detail.pigLineCustomerInfo || {}}}),_c('FeedInfo',{attrs:{"detail":_vm.detail || {}}}),_c('CustomerFeedback',{attrs:{"detail":_vm.detail.pigLineFeedBackReq || {}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }